import { createSlice } from '@reduxjs/toolkit';

import { LoadingState } from '@nocowanie/core';

import { sectionToStateKeyMap } from '@app/consts';
import { SliceNameEnum } from '@app/enums';

import { getCmsSectionData } from './cms-homepage.thunks';
import { CmsHomepageState } from './cms-homepage.types';

const defaultSectionState = {
    data: null,
    loading: LoadingState.IDLE,
    error: null,
};

const initialState: CmsHomepageState = {
    heroSection: {
        ...defaultSectionState,
    },
    destinationSuggestions: {
        ...defaultSectionState,
    },
};

const cmsHomepageSlice = createSlice({
    name: SliceNameEnum.CmsHomepage,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getCmsSectionData.pending, (state, action) => {
                const { section } = action.meta.arg;
                const stateKey = sectionToStateKeyMap[section];

                if (stateKey && state[stateKey]) {
                    state[stateKey].loading = LoadingState.PENDING;
                    state[stateKey].error = null;
                }
            })
            .addCase(getCmsSectionData.fulfilled, (state, action) => {
                const { section, data } = action.payload;
                const stateKey = sectionToStateKeyMap[section];

                if (stateKey && state[stateKey]) {
                    state[stateKey].data = data;
                    state[stateKey].loading = LoadingState.SUCCESS;
                    state[stateKey].error = null;
                }
            })
            .addCase(getCmsSectionData.rejected, (state, action) => {
                const { section } = action.meta.arg;
                const stateKey = sectionToStateKeyMap[section];

                if (stateKey && state[stateKey]) {
                    state[stateKey].loading = LoadingState.ERROR;
                    state[stateKey].error =
                        action.error.message || `Failed to fetch CMS section: ${section}`;
                }
            });
    },
});

const actions = { getCmsSectionData };
const cmsHomepageReducer = cmsHomepageSlice.reducer;

export { actions, cmsHomepageReducer, cmsHomepageSlice };
